// unsubscribePrivateGoalV2Channel.js
'use strict';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';

/**
 * Unsubscribe private goal v2 channel
 * @kind action
 * @param {string} {goalId} - goal id.
 * @param {string} {userId} - user id.
 * @return {Promise} Action promise.
 */
const unsubscribePrivateGoalV2Channel =
  ({ goalId, userId }) =>
  async dispatch => {
    if (!goalId || !userId) {
      return dispatch({ type: '' });
    }
    return sendMessageToSW({
      type: MessageTypes.UNSUBSCRIBE_PRIVATE_GOAL_V2_CHANNEL,
      payload: {
        goalId,
        userId,
      },
    });
  };

export default unsubscribePrivateGoalV2Channel;
